import * as types from './types'
import storage from '@/plugins/storage'
import globals from '@/plugins/globals.js'
import sendbird from '../chat/sendbird.js'
export default {
  [types.RESET_LOGIN](state) {
    state.solution = null
    state.language = ''
    state.isLogout = true
    state.roles = null
    state.token = null
    state.username = null
    state.userProfile = null
    state.fullUserData = null
    state.demoMode = 'false'
    state.userIsMahle = 'false'
    state.userIsTechPro = 'false'
    storage.session.clear()
    storage.local.clear()
    storage.local.setItem(types.SESSION_USER_TOKEN, JSON.stringify(state.userToken))
    sendbird.disconnect()
  },
  [types.RESET_MAHLE_COIN_BALANCE](state) {
    state.mahleCoinBalance = null
    storage.local.setItem(types.SESSION_MAHLE_COIN_BALANCE, null)
  },
  [types.RESET_USER_ISMAHLE](state) {
    state.userIsMahle = 'false'
    storage.local.setItem(types.SESSION_USER_ISMAHLE, 'false')
  },
  [types.RESET_USER_ISTECHPRO](state) {
    state.userIsTechPro = 'false'
    storage.local.setItem(types.SESSION_USER_ISTECHPRO, 'false')
  },
  [types.RESET_MAHLE_DIAGNOSTIC_LICENSE_STATUS](state) {
    state.mahleDiagnosticLicenseStatus = null
    storage.local.setItem(types.SESSION_MAHLE_DIAGNOSTIC_LICENSE_STATUS, null)
  },
  [types.RESET_MAHLE_API_ERROR_MSG](state) {
    state.mahleApiErrorMsg = null
    storage.local.setItem(types.SESSION_MAHLE_API_ERROR_MSG, null)
  },
  [types.SET_MAHLE_COIN_COUNT](state, coinCount) {
    storage.local.setItem(types.SET_MAHLE_COIN_COUNT, coinCount)
    state.mahleCoinBalance = coinCount
  },
  [types.SET_MAHLE_DIAGNOSTIC_LICENSE_STATUS](state, status) {
    storage.local.setItem(types.SET_MAHLE_DIAGNOSTIC_LICENSE_STATUS, status)
    state.mahleDiagnosticLicenseStatus = status
  },
  [types.SET_MAHLE_API_ERROR_MSG](state, msg) {
    storage.local.setItem(types.SET_MAHLE_API_ERROR_MSG, msg)
    state.mahleApiErrorMsg = msg
  },
  [types.SET_USER_ISMAHLE](state, isMahle) {
    storage.local.setItem(types.SET_USER_ISMAHLE, isMahle)
    state.userIsMahle = isMahle
  },
  [types.SET_USER_ISTECHPRO](state, isTechpro) {
    storage.local.setItem(types.SET_USER_ISTECHPRO, isTechpro)
    state.userIsTechPro = isTechpro
  },
  [types.SET_USER_INFO](state, info) {
    state.userInfo = info
    state.language = info.language
    // Store roles with their IDs for RAG Only checking
    if (info.Roles && Array.isArray(info.Roles)) {
      state.userProfile = {
        ...state.userProfile,
        roles: info.Roles // Store the full role objects with IDs
      }
    }
  },
  [types.SET_TOKEN](state, token) {
    state.token = token
    storage.local.setItem(types.SESSION_TOKEN_NAME, token)
  },
  [types.SET_SOLUTION](state, solution) {
    state.solution = solution
    storage.local.setItem(types.SESSION_SOLUTION, solution)
  },
  [types.SET_ROLES](state, profile) {
    state.primaryRole = ''
    if (profile && profile.Roles && profile.Roles.length) {
      let roles = profile.Roles.map(r => r.Name)
      state.roles = roles
      storage.local.setItem(
        types.SESSION_ROLES_NAME,
        JSON.stringify(roles)
      )
      for (let role of roles) {
        if (role === 'InShopTech' || role === 'DiagCoord') {
          state.primaryRole = 'Tech'
          break
        } else if (role === 'MasterTech') {
          state.primaryRole = 'MasterTech'
          break
        } else if (role === 'Dispatch') {
          state.primaryRole = 'Dispatch'
          break
        }
      }
      if (state.primaryRole === '') {
        state.primaryRole = roles[0]
      }
    }
    storage.local.setItem(
      types.SESSION_PRIMARY_ROLE,
      JSON.stringify(state.primaryRole)
    )
    state.userProfile = null
    if (profile) {
      state.userProfile = {
        id: profile.Id || profile.UserId,
        location: profile.Location,
        timeZone: profile.TimeZone,
        firstName: profile.GivenName || profile.FirstName,
        lastName: profile.FamilyName || profile.LastName,
        userName: profile.Username,
        email: profile.Email,
        phone: '',
        isNew: true,
        isUK: profile.IsUK,
        contact: null,
        IsTechPro: profile.IsTechpro,
        IsTexa: profile.IsTexa
      }
      storage.local.setItem(
        types.SESSION_USER_PROFILE,
        JSON.stringify(state.userProfile)
      )
      globals.username = profile.Username
      globals.email = profile.Email
      console.log('Language 1', state.language)
    }
  },
  [types.SET_PASSTHROUGH](state, passthrough) {
    state.passthrough = passthrough
  },
  [types.SET_LOCATION_KEY](state, data) {
    state.userProfile.location.key = data.sid
    state.userProfile.location.isHunterClient = data.isHunterClient
    storage.local.setItem(
      types.SESSION_USER_PROFILE,
      JSON.stringify(state.userProfile)
    )
  },
  [types.SET_BUSINESS_USERS](state, data) {
    state.businessUsers = []
    data.forEach(element => {
      if (element.id !== null && element.isAstechUser) {
        state.businessUsers.push({
          value: element.id,
          name: `${element.firstName} ${element.lastName}`
        })
      }
    })
  },
  [types.SET_CONTACT](state, id) {
    for (let user of state.businessUsers) {
      if (user.id === id) {
        state.userProfile.id = id
        state.userProfile.firstName = user.firstName
        state.userProfile.lastName = user.lastName
        state.userProfile.email = user.email
        state.userProfile.phone = user.phone
        state.userProfile.isNew = false
        state.userProfile.contact = null
        storage.local.setItem(
          types.SESSION_USER_PROFILE,
          JSON.stringify(state.userProfile)
        )
        break
      }
    }
  },
  [types.SET_CONTACT_ID](state, id) {
    state.userProfile.contactId = id
    storage.local.setItem(
      types.SESSION_CONTACT_ID,
      JSON.stringify(state.userProfile)
    )
  },
  [types.SET_USERINFO](state, userInfo) {
    state.userProfile.id = userInfo.id
    state.userProfile.firstName = userInfo.firstName
    state.userProfile.lastName = userInfo.lastName
    state.userProfile.email = userInfo.email
    state.userProfile.phone = userInfo.phone
    storage.local.setItem(
      types.SESSION_USER_PROFILE,
      JSON.stringify(state.userProfile)
    )
  },

  [types.SET_PHONE](state, phone) {
    state.userProfile.phone = phone
    storage.local.setItem(
      types.SESSION_USER_PROFILE,
      JSON.stringify(state.userProfile)
    )
  },
  [types.UPDATE_CONTACT](state, data) {
    state.userProfile.firstName = data.firstName
    state.userProfile.lastName = data.lastName
    state.userProfile.email = data.email
    state.userProfile.phone = data.phone
    state.userProfile.isNew = false
    state.userProfile.contact = data.contact
    storage.local.setItem(
      types.SESSION_USER_PROFILE,
      JSON.stringify(state.userProfile)
    )
    state.userToken = {
      id: data.contact,
      token: data.email
    }
    storage.local.setItem(types.SESSION_USER_TOKEN, JSON.stringify(state.userToken))
  },
  [types.SET_LANGUAGE](state, language) {
    state.language = language
    storage.local.setItem(types.SESSION_LANGUAGE, language)
  },
  [types.SHOW_LOGGING](state, isShow) {
    state.showLog = isShow
  },
  [types.SET_LOGGING](state, data) {
    state.isLogging = data
  },
  [types.SET_LOG_ENTRY](state, data) {
    let date = new Date()
    let hours = date.getHours()
    let minutes = date.getMinutes()
    let ampm = hours >= 12 ? 'pm' : 'am'
    hours = hours % 12
    hours = hours || 12 // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes
    let time = hours + ':' + minutes + ' ' + ampm
    data.time = time
    if (data.hasOwnProperty('isSystem')) {
      let idx = state.systemLog[state.systemLog.length - 1].id
      data.id = idx + 1
      state.systemLog.push(data)
    }
    if (state.isLogging) {
      if (state.log.length > 100) {
        state.log = state.systemLog.concat(state.log.slice(-100))
      }
      data.id = state.log.length + 1
      state.log.push(data)
    }
  },
  [types.CLEAR_LOG](state) {
    state.log = state.systemLog.concat([{
      id: 0,
      component: 'main',
      method: 'init',
      text: 'starting log'
    }])
  },
  [types.SET_NOTIFICATION_TOKEN](state, token) {
    state.notificationToken = token
    storage.local.setItem(types.SESSION_NOTIFICATION_TOKEN, token)
  },
  [types.SET_TERMANDCONDITIONS_UI_MESSAGE](state, message) {
    state.termAndConditionsUIMessage = message
  },
  [types.SET_USER_RAG_ONLY](state, isRagOnly) {
    state.isRagOnly = isRagOnly
    storage.local.setItem(types.SESSION_RAG_ONLY, isRagOnly.toString())
  },
  [types.SET_USER_SHOW_RAG](state, showRag) {
    state.showRag = showRag
    storage.local.setItem(types.SESSION_SHOW_RAG, showRag.toString())
  },
  [types.SET_FULL_USER_DATA](state, userData) {
    state.fullUserData = userData
    storage.local.setItem(types.SESSION_FULL_USER_DATA, JSON.stringify(userData))

    console.log('Stored in state.fullUserData:', state.fullUserData)
    console.log('state.fullUserData.Language:', state.fullUserData.Language)
    console.log('=====================================')
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutations.js